import React from 'react';
import '../../index.css';
import intl from 'react-intl-universal';

import N2_lite_header from "../../images/N2_lite_manual/header.png"
import N2_lite_en from "../../images/N2_lite_manual/en.png"
import N2_lite_vn from "../../images/N2_lite_manual/vn.png"
import N2_lite_pt from "../../images/N2_lite_manual/pt.png"
import N2_lite_tr from "../../images/N2_lite_manual/tr.png"

import N2_header from "../../images/N2_manual/header.jpg"
import N2_en from "../../images/N2_manual/en.jpg"
import N2_fr from "../../images/N2_manual/fr.jpg"
import N2_de from "../../images/N2_manual/de.jpg"
import N2_jp from "../../images/N2_manual/jp.jpg"
import N2_cn from "../../images/N2_manual/cn.jpg"

import Q11_header from "../../images/Q11_manual/header.jpg"
import Q11_en from "../../images/Q11_manual/en.jpg"
import Q11_fr from "../../images/Q11_manual/fr.jpg"
import Q11_de from "../../images/Q11_manual/de.jpg"
import Q11_jp from "../../images/Q11_manual/jp.jpg"
import Q11_cn from "../../images/Q11_manual/cn.jpg"

import S5C_header from "../../images/S5C_manual/header.jpg"
import S5C_en from "../../images/S5C_manual/en.jpg"
import S5C_fr from "../../images/S5C_manual/fr.jpg"
import S5C_de from "../../images/S5C_manual/de.jpg"
import S5C_jp from "../../images/S5C_manual/jp.jpg"
import S5C_cn from "../../images/S5C_manual/cn.jpg"
import S5C_cn1 from "../../images/S5C_manual/cn1.jpg"

import Korea_manual from "../../images/Korea_manual/korea_manual.jpg"


class Page1 extends React.Component {
    
    // onChange = (key) => {
    //     console.log(key);
    // }
    render() {
        let question = this.props.location.state.data
        let answer = question.replace('q','a');
        let titleStyle = {fontSize:'20px',borderBottom:'solid 1px #ddd',paddingBottom:'20px'};
        let contentStyle = {fontSize:'16px',color:'dimgrey'};
        
        // console.log(this.props.location.state.data)
        if(answer == "N1P-a0"){
            return (
                <div>
                    <img style={{ width: '100%' }} src={S5C_header}></img>
                    <img style={{ width: '100%' }} src={S5C_en}></img>
                    <img style={{ width: '100%' }} src={S5C_fr}></img>
                    <img style={{ width: '100%' }} src={S5C_de}></img>
                    <img style={{ width: '100%' }} src={S5C_jp}></img>
                    <img style={{ width: '100%' }} src={S5C_cn}></img>
                    <img style={{ width: '100%' }} src={S5C_cn1}></img>
                </div>
            );
        }
        else if(answer == 'Q11-a0'){
            if(navigator.language == "ko" || navigator.browserLanguage == "ko" || navigator.systemLanguage == "ko" || navigator.userLanguage == "ko"){
                return (
                    <div>
                        <img style={{ width: '100%' }} src={Korea_manual}></img>
                    </div>
                );
            }
            else {
                return (
                    <div>
                        <img style={{ width: '100%' }} src={Q11_header}></img>
                        <img style={{ width: '100%' }} src={Q11_en}></img>
                        <img style={{ width: '100%' }} src={Q11_fr}></img>
                        <img style={{ width: '100%' }} src={Q11_de}></img>
                        <img style={{ width: '100%' }} src={Q11_jp}></img>
                        <img style={{ width: '100%' }} src={Q11_cn}></img>
                    </div>
                );
            }
        }
        else if (answer == 'N2-a0') {
            return (
                <div>
                    <img style={{ width: '100%' }} src={N2_header}></img>
                    <img style={{ width: '100%' }} src={N2_en}></img>
                    <img style={{ width: '100%' }} src={N2_fr}></img>
                    <img style={{ width: '100%' }} src={N2_de}></img>
                    <img style={{ width: '100%' }} src={N2_jp}></img>
                    <img style={{ width: '100%' }} src={N2_cn}></img>
                </div>
            );
        } else if (answer == "N2Lite-a0") {
            return (
                <div>
                    <img style={{ width: '100%' }} src={N2_lite_header}></img>
                    <img style={{ width: '100%' }} src={N2_lite_en}></img>
                    <img style={{ width: '100%' }} src={N2_lite_vn}></img>
                    <img style={{ width: '100%' }} src={N2_lite_tr}></img>
                    <img style={{ width: '100%' }} src={N2_lite_pt}></img>
                </div>
            );
        }else{
            return (
                <div className="body_pad">
                    <p style={titleStyle}>{intl.get(question)}</p>
                    <div style={contentStyle}>{intl.getHTML(answer)}</div>  
                </div>              
            );
        }

    }
}
export default Page1;
